import { productsReducer } from '@quiz-frontend/dressfinder/store/products/reducer';
import { savingReducer } from '@quiz-frontend/dressfinder/store/saving/reducer';
import { sharingReducer } from '@quiz-frontend/dressfinder/store/share/reducer';
import { sharingEmailReducer } from '@quiz-frontend/dressfinder/store/sharing-email/reducer';
import { reducers as builderReducers } from '@quiz-frontend/quiz-builder/store/root-reducer';
import { combineReducers } from 'redux';

const reducers = {
  productsState: productsReducer,
  savingState: savingReducer,
  sharingState: sharingReducer,
  sharingEmailState: sharingEmailReducer,
  ...builderReducers,
};

type ReducerType = typeof reducers;
export type RootState = { [K in keyof ReducerType]: ReturnType<ReducerType[K]> };

const createRootReducer = () => combineReducers(reducers);

export default createRootReducer;
